import { render } from "./v2Feedback.vue?vue&type=template&id=347df6c8"
import script from "./v2Feedback.vue?vue&type=script&lang=js"
export * from "./v2Feedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__